<template>
<div class="page_transport">
  <div class="container py-5">
    <div class="page_topic_blcok my-4">
      <div class="topic_border">
        <p class="topic_eng">FORGET PASSWORD</p>
        <p class="topic_cht">忘記密碼</p>
      </div>
    </div>
    <!-- 忘記密碼 -->
    <div class="member_title">
      <!--<h2>
        <img src="@/assets/icons/member_title.png" /> 忘記密碼
      </h2>-->
    </div>
    <div class="member_forget_block">
      <!-- 表單開始 -->
      <form class="member_forget_box">
        <h6>請輸入您註冊的E-mail(帳號)，我們會發送一封「重設密碼通知信」給您；請至您的E-mail信箱收取「重設密碼通知信」，依信件指示登入會員中心並修改密碼</h6>
        <div>
          <label for="company_no"><span class="require_mark">*</span> 帳號/公司統編</label>
          <input type="text" class="member_input member_input_md">
        </div>
        <div>
          <label for="company_no"><span class="require_mark">*</span> 連絡人 E-mail</label>
          <input type="text" class="member_input member_input_md" style="margin-left:5px;">
        </div>
        <!-- 驗證碼 -->
        <div>
          <label for="member_join_verify"><span class="require_mark">* </span>驗證碼</label>
          <input class="member_input member_input_sm" id="member_join_verify" type="text" placeholder="請輸入右方數字" />
          <div style="display:inline-flex;width:80px;height:35px;border:1px solid black;align-items:center;justify-content:center;">
            <span><em>1547</em></span>
          </div>
          <div><a href="#">刷新驗證碼</a></div>
        </div>
        <!-- 按鈕 -->
        <button class="submit_btn red" style="margin-top:20px;">確 認 送 出</button>
      </form>

      <!-- 貼心提醒 -->
      <p style="max-width:750px;margin:30px auto 0;"><span style="color:red;">貼心提醒：</span><br>
        <ol style="margin:0;padding:0;list-style-position:inside;">
          <li>因各家E-mail信箱的收件效率不同，請您耐心等候，若5分鐘後尚未收到信件，請再次操作。</li>
          <li>使用Yahoo、PChome、Hotmail等免費信箱，信件有可能被誤判為垃圾信，請先至「垃圾信匣」查看，若仍收不到，請重新操作。</li>
          <li>會員若無法收信、或E-mail信箱有誤，請與客服人員聯絡，並提供您註冊時的「公司統編」、「E-mail」以供查證。</li>
        </ol>
      </p>
    </div>

  </div>  
</div>



</template>

<script>
export default {
  data () {
    return{};
  }
}
</script>

<style>
.member_title>h2 {
  border-bottom:3px solid rgb(10, 116, 0);
  padding:4px 0;
}
.member_forget_box {
  max-width:600px;
  margin:auto;
  text-align:center;
}
.member_forget_box>h6 {
  padding:20px 0;
}
.member_forget_box>div {
  display:flex;
  justify-content:center;
  align-items:baseline;
  margin-top:10px;
  flex-wrap:wrap;
}
.member_forget_box label {
  font-weight:bold;
}


.member_input {
  height:35px;
  margin:0 3px;
  font-size:15px;
}
.member_input.member_input_xs {
  width:60px;
}
.member_input.member_input_sm {
  width:130px;
}
.member_input.member_input_md {
  width:200px;
}
.member_input.member_input_lg {
  width:400px;
}


.sub_label {
  font-size:15px;
}

.member_join_box div>label {
  font-weight:bold;
}
.require_mark {
  color:red;
}

.member_contract>p {
  margin:0 0 8px;
}


/**page_topic**/
.page_topic_blcok { 
  display:inline-block; 
  text-align: right;
}
.page_topic_blcok .topic_border { 
  padding: 0px 1rem 1px 0;
  border-right:1px solid #d6d6d6; 
  font-size:2rem; 
  line-height:1.1;
}
.page_topic_blcok .topic_border .topic_eng { 
  color:#8c8c8d;
  line-height:1.5;
  margin:0;
}
.page_topic_blcok .topic_border .topic_cht { 
  color:#b0b0b0;
  line-height:1.5;
  letter-spacing:9px;
  margin-right:-9px; 
}

/* btn */
.submit_btn{
  outline:none;
  border:0;
  margin:0;
  padding:0;
  box-sizing: border-box;
}
.submit_btn.red{
  background: rgba(255, 0, 51, 1);
  color:white;
  width:140px;
  height:40px;
  border:1px solid rgba(255, 255, 255, 1);
  border-radius: 5px;
  box-shadow: 5px 5px 5px rgba(0, 0, 0, 0.35);
}
.submit_btn.blue{
  background: rgba(25, 158, 216, 1);
  color:white;
  width:140px;
  height:40px;
  border:1px solid rgba(255, 255, 255, 1);
  border-radius: 5px;
  box-shadow: 5px 5px 5px rgba(0, 0, 0, 0.35);
}
</style>



// WEBPACK FOOTER //
// src/components/pages/forget_password.vue